import React from 'react'
import { TypographyProps as MUITypographyProps } from '@mui/material'
import { TypographyStyled } from './styles'

export type DSTypographyType =
  | 'hav-h1-text'
  | 'hav-h2-text'
  | 'hav-h3-text'
  | 'hav-h4-text'
  | 'hav-h5-text'
  | 'hav-h6-text'
  | 'hav-h7-text'
  | 'hav-h8-text'
  | 'hav-subtitle-text'
  | 'hav-default-01-text'
  | 'hav-default-02-text'
  | 'hav-default-02-disabled'
  | 'hav-default-03-text'
  | 'hav-default-04-text'
  | 'hav-default-05-text'
  | 'hav-helper-text'
  | 'hav-helper-02-text'
  | 'accordion-title'

export interface TypographyProps extends MUITypographyProps {
  design?: DSTypographyType
  disabled?: boolean
}

export const Typography: React.FC<TypographyProps> = ({
  children,
  variant = 'body1',
  design = 'hav-default-01-text',
  disabled = false,
  className
}) => {
  return (
    <TypographyStyled
      disabled={disabled}
      variant={variant}
      design={design}
      {...(className && { className })}
    >
      {children}
    </TypographyStyled>
  )
}
